import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTASection() {
  return <section className="pt-10 pb-16 relative" data-id="element-24">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-25">
        <div className="border-4 border-black p-6 bg-white text-black relative overflow-hidden" data-id="element-26">
          <h3 className="text-xl font-bold mb-4" data-id="element-27">LET'S DO THIS</h3>
          <div className="space-y-4 mb-6" data-id="element-28">
            {[{
            step: '1',
            text: "Reach out. Tell me what clicked. What made you feel like this is the thing you've been waiting to back.",
            color: '#8800FF'
          }, {
            step: '2',
            text: 'We talk. Not about decks or projections. About vision. About what kind of internet we want to build.',
            color: '#FF8800'
          }, {
            step: '3',
            text: 'Then we partner up. However that looks. Mentorship. Investment. Introductions. Whatever helps us win.',
            color: '#00DD00'
          }].map((item, i) => <div key={i} className="flex items-start" data-id="element-29">
                <div className="w-8 h-8 flex items-center justify-center font-bold text-black mr-3 flex-shrink-0 text-sm border-2 border-black" style={{
              backgroundColor: item.color
            }} data-id="element-30">
                  {item.step}
                </div>
                <span className="text-base leading-relaxed" data-id="element-31">{item.text}</span>
              </div>)}
          </div>
          <div className="grid grid-cols-2 gap-4" data-id="element-32">
            <motion.a href="mailto:dunjaslazic@gmail.com?subject=I want to mentor" className="py-3 text-black font-bold text-sm border-4 border-black relative overflow-hidden block text-center no-underline" style={{
            backgroundColor: '#0088FF'
          }} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-33">
              MENTOR ME
            </motion.a>
            <motion.a href="mailto:dunjaslazic@gmail.com?subject=I want to invest" className="py-3 text-black font-bold text-sm border-4 border-black relative overflow-hidden block text-center no-underline" style={{
            backgroundColor: '#8800FF'
          }} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-34">
              INVEST
            </motion.a>
          </div>
        </div>
      </motion.div>
    </section>;
}